import { Document } from "api/uploads";
import { CollapsableSection, FormLink } from "lqx-react/lib/forms";
import React from "react";

export const CommentsCollapsable = ({ attachment, comment }: {
    attachment: Document,
    comment: string
}) => {
    return (
        <CollapsableSection title="Comments">
            <p>{attachment && attachment.file_comments || comment}</p>
            <FormLink label="Attachments" linkLabel={attachment && attachment.file_name} onClick={() => attachment && attachment.download()} />
        </CollapsableSection>
    )
}